//检验方式
export const getInspectionMethod = (e: number) => {
    switch (e) {
        case 0:
            return '免检'
        case 1:
            return '抽检(减量)'
        case 2:
            return '抽检(正常)'
        case 3:
            return '抽检(加严)'
        case 4:
            return '全检'
    }
}
// 送货单管理主列表状态Tag颜色判断
export const getStatus = (e: number) => {
    switch (e) {
        case -1:
            return "#1e90ff"
        case 0:
            return "#5352ed"
        case 1:
            return "#ff6348"
        case 2:
            return "#e66767"
    }
}
// 送货单管理主列表状态Tag文字判断
export const getText = (e: number) => {
    switch (e) {
        case -1:
            return "撤销"
        case 0:
            return "未进行"
        case 1:
            return "进行中"
        case 2:
            return "完成"
    }
}
// 编辑按钮的状态
export const getTextStatus = (scope: any) => {
    if(scope.isJiaJiJian==1){
        return true
    }else if(scope.purchaseNumber == scope.deliveryQuantityTotal){
        return true
    }else{
        switch (scope.status) {
            case 0:
                return false
            case 1:
                return false
            case 2:
                return true
        }
    }    
}
// 送货单管理详情列表中状态Tag颜色判断
export const getDetailsText = (e: number) => {
    switch (e) {
        case 0:
            return "#1e90ff"
        case 1:
            return "#5352ed"
        case 2:
            return "#ff6348"
        case 3:
            return "#e66767"
        case 4:
            return "#f19066"
        case 5:
            return "#67C23A"
        case 6:
            return "#909399"
    }
}
// 送货单管理详情列表中状态Tag文字判断
export const getDetailsStatus = (e: number) => {
    switch (e) {
        case 0:
            return "预约中"
        case 1:
            return "预约成功"
        case 2:
            return "审核中"
        case 3:
            return "驳回"
        case 4:
            return "审核通过"
        case 5:
            return "送货中"
        case 6:
            return "送货完成"
    }
}
// 编辑按钮的状态
export const getEditStatus = (scope: any) => {
    if(scope.purchaseTypeName=='加急件'){
        return false
    }else{
        switch (scope.status) {
            case 0:
                return false
            case 1:
                return true
            case 2:
                return true
            case 3:
                return true
            case 4:
                return true
            case 5:
                return true
            case 6:
                return true
        }
    }
   
    
}
export const getStepsColor = (e: number) => {
    switch (e) {
        case 0:
            return "#1e90ff"
        case 1:
            return "#5352ed"
        case 2:
            return "#ff6348"
        case 3:
            return "#e66767"
        case 4:
            return "#f19066"
        case 5:
            return "#67C23A"
        case 6:
            return "#909399"
    }
}